export type FlowTemplate = {
	config: {
		title: string,
		template: FlowTemplateNames
		data?: {
			channel: number | null,
		}
	}
	about: {
		description: string
		image: any,
		video: any
	}
}

export enum FlowTemplateNames {
	WineCatalog = 'WineCatalog',
	HotSale = 'HotSale',
	PaidSubscription = 'PaidSubscription',
	Marathon = 'Marathon',
	QuestionnaireSubscription = 'QuestionnaireSubscription',
	SuggestContent = 'SuggestContent',
}

export enum ActiveBotLicenseSteps {
	Start,
	SelectTemplate,
	ConfigureTemplate,
}

export enum WizardMode {
	Flow,
	LicenseFlow,
}

export type WizardComplete = {
  board_key?: string
  template?: FlowTemplate['config'] | undefined
}
